import Component from "../../lib/component";

export const PaneSlidesPaginationConfig = {
    componentTypeKey: 'PaneSlidesPagination',
    baseHtmlClass: 'pane_slides__pagination',
    selector: '.pane_slides__pagination',

    dotHtmlClass: 'pane_slides__pagination__dot',
    dotActiveHtmlClass: 'pane_slides__pagination__dot--active',
    dotLabelHtmlClass: 'pane_slides__pagination__dot__label',
};

// The carousel's dot pagination (opt-in via the pane_slides `pagination` config flag). One button
// per slide; the focused slide's dot morphs into a labelled pill (see _pane_slides__pagination.scss
// for the motion). Labels come from each slide's `label` dataset config, falling back to ordinals.
export class PaneSlidesPagination extends Component {

    static get config() {
        return PaneSlidesPaginationConfig;
    }

    static createElement(parentElement) {
        const element = Component.createElement(PaneSlidesPagination.config.baseHtmlClass);
        element.setAttribute('aria-label', 'Slides');
        // Ahead of the slides, so `position: sticky` pins it from the top of the scrollport.
        parentElement.insertBefore(element, parentElement.firstChild);
        return element;
    }

    constructor(id_or_element, paneSlides) {
        super({
            element: id_or_element,
            config: PaneSlidesPagination.config
        });

        this.paneSlides = paneSlides;
        this.dotElements = this.paneSlides.slides.map((slide, index) => createDotElement(this, slide, index));

        this.applyPlacement();
    }

    // Placement comes from the carousel's `pagination_placement` config: space-separated tokens,
    // horizontal `left` (default) / `right`, vertical `start` / `middle` (default) / `end` —
    // e.g. "right end" is the bottom-right corner. Defaults carry no modifier class.
    applyPlacement() {
        const tokens = String(this.paneSlides.getDatasetConfigValue('pagination_placement') || '').split(/\s+/);
        this.conditionallySetHtmlClassState(tokens.indexOf('right') !== -1, 'right');
        this.conditionallySetHtmlClassState(tokens.indexOf('start') !== -1, 'start');
        this.conditionallySetHtmlClassState(tokens.indexOf('end') !== -1, 'end');
    }

    render() {
        this.paneSlides.slides.forEach((slide, index) => {
            const isActive = slide === this.paneSlides.focusedSlide;
            const dotElement = this.dotElements[index];
            dotElement.classList.toggle(PaneSlidesPagination.config.dotActiveHtmlClass, isActive);
            if (isActive) {
                dotElement.setAttribute('aria-current', 'true');
            } else {
                dotElement.removeAttribute('aria-current');
            }
        });
    }

    handleDotClick(slide) {
        slide.slideTo(slide);
    }

}

function createDotElement(pagination, slide, index) {
    const element = document.createElement('button');
    element.setAttribute('type', 'button');
    element.classList.add(PaneSlidesPagination.config.dotHtmlClass);

    const label = slide.getDatasetConfigValue('label') || `Slide ${index + 1}`;
    element.setAttribute('aria-label', `Go to ${label}`);

    const labelElement = document.createElement('span');
    labelElement.classList.add(PaneSlidesPagination.config.dotLabelHtmlClass);
    labelElement.setAttribute('aria-hidden', 'true'); // The button's aria-label already carries it.
    labelElement.textContent = label;
    element.appendChild(labelElement);

    element.addEventListener('click', () => pagination.handleDotClick(slide));
    pagination.element.appendChild(element);
    return element;
}
